import styled from 'styled-components';
import { Backdrop } from 'aa-react-ui';

const FadedBackdrop = styled(Backdrop)`
    opacity: 0.4;
`;

export default FadedBackdrop;
